/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/criteria';

// Helpers
import { downloadJsonFile } from '../../../../common/helpers/downloadFile';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_EXPORT);

export const useExportCriteria = ({ sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (criteriaId) => Client.fetchOneForExport(sessionToken, criteriaId),
        onSuccess: (data) => {
            downloadJsonFile(data);
            Messenger.showMessage({
                type: `success`,
                title: 'Criteria export downloading.'
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
